var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSatellites(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.752 10.452c.448-.837 1.58-.814 2.27-.122l2.6 2.6.708-.71a1.247 1.247 0 012.12-1.058 1.247 1.247 0 01-1.06 2.12l-.708.708 2.6 2.6c.691.692.715 1.823-.122 2.27-.88.47-1.879.715-2.909.698l-.303-.011a6.305 6.305 0 01-3.816-1.632l-.223-.212a6.314 6.314 0 01-1.843-4.04l-.012-.301a5.966 5.966 0 01.698-2.91zm1.207.938a4.48 4.48 0 00-.405 1.947 4.803 4.803 0 001.416 3.305 4.804 4.804 0 003.305 1.417 4.48 4.48 0 001.93-.398l.017-.01-6.26-6.26h-.003z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.413 7.198a4.995 4.995 0 013.442 1.469 4.995 4.995 0 011.468 3.441.751.751 0 01-1.5.023 3.495 3.495 0 00-1.029-2.404 3.493 3.493 0 00-2.404-1.03.75.75 0 01.023-1.5z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.518 4.26a7.606 7.606 0 015.533 2.21 7.606 7.606 0 012.21 5.534.751.751 0 01-1.5-.028 6.107 6.107 0 00-1.77-4.445 6.106 6.106 0 00-4.446-1.77.75.75 0 01-.027-1.5z",
    fill: "currentColor"
  })));
}
SvgPokerSatellites.displayName = 'PokerSatellites';
export default SvgPokerSatellites;